import { WidgetGroup } from '../../../interfaces/UserInterfaces';
import { WidgetConfiguration } from '../../../interfaces/WidgetInterfaces';

export class BreadCrumb {
    name: string;
    display: string;
    tooltip: string;
    close: boolean;
    prevValues?: string[];
    constructor(name: string, display: string, close: boolean) {
      this.name = name;
      this.display = display;
      this.tooltip = display;
      this.close = close;
      if (this.display && this.display.length > 30) {
        this.display = this.display.substr(0, 27) + '...';
      }
    }
  }

  export class WidgetDisplayGroup {
    heightStyle = '';
    widthStyle =  '';
    ordinal: number;
    widgetList: OrderedWidget[] = [];
    sourcewidgetGroup: WidgetGroup;
    constructor(groupNumber: number, sourcewidgetGroup: WidgetGroup) {
      this.ordinal = groupNumber;
      this.sourcewidgetGroup = sourcewidgetGroup;
    };
  }

  export class OrderedWidget {
    widgetConfiguration: WidgetConfiguration;
    index: number;
    constructor(widgetConfiguration: WidgetConfiguration,
      index: number) {
      this.widgetConfiguration = widgetConfiguration;
      this.index = index;
    }
  }
